import React, { ReactNode } from "react";
import styled, { css } from "styled-components";

import { useIsMobile } from "src/hooks/useIsMobile";
import { colors } from "src/styles";

export interface TableCellProps {
  children: ReactNode;
  $isLink?: boolean;
  $appearance?: "modern" | "legacy";
}
interface StyledTableCellProps {
  $isMobile?: boolean;
  $isLink?: boolean;
  $appearance?: "modern" | "legacy";
}
const TableCell = ({ children, $isLink, $appearance = "modern" }: TableCellProps) => {
  const { isMobile } = useIsMobile();

  return (
    <StyledTableCell $appearance={$appearance} $isLink={$isLink} $isMobile={isMobile}>
      {children}
    </StyledTableCell>
  );
};
export default TableCell;

export const StyledTableCell = styled.td<StyledTableCellProps>`
  padding: ${({ $appearance }) => ($appearance === "legacy" ? "15px" : "14px 16px")};
  font-style: normal;
  font-size: ${({ $appearance }) => ($appearance === "legacy" ? "14px" : "13px")};
  color: ${({ $appearance }) => ($appearance === "legacy" ? colors.grey.dark3 : colors.black.dark1)};
  width: ${({ $appearance }) => ($appearance === "legacy" ? "200px" : "auto")};
  vertical-align: middle;
  border-top: ${({ $appearance }) => ($appearance === "legacy" ? "0" : `1px solid ${colors.grey.light3}`)};
  border-bottom: ${({ $appearance }) => ($appearance === "legacy" ? `1px solid ${colors.grey.light15}` : "0")};
  line-height: 1.4;

  & .bold {
    font-weight: 600;
  }

  ${({ $isMobile }: { $isMobile?: boolean }) =>
    $isMobile &&
    css`
      padding: 8px;
    `}
  ${({ $isLink }: { $isLink?: boolean }) =>
    $isLink &&
    css`
      text-decoration: underline;
      cursor: pointer !important;
    `}
`;
